var loadTrustedBySlider = function loadTrustedBySlider() {
  var slider = document.querySelector(".home-trusted-by__wrapper .splide");
  if (slider) {
    var splide = new Splide(slider, {
      arrows: false,
      pagination: false,
      type: "slide",
      perPage: 4.3,
      gap: 23,
      focus: 0,
      breakpoints: {
        1200: {
          perPage: 3.2,
          gap: 16
        },
        600: {
          perPage: 1.6
        }
      }
    });
    var bar = document.querySelector(".home-trusted-by__wrapper .splide-progress-bar");
    splide.on("mounted move", function () {
      var end = splide.Components.Controller.getEnd() + 1;
      var rate = Math.min((splide.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + "%";
    });
    splide.mount();
  }
};
loadTrustedBySlider();